module.exports = __webpack_public_path__ + "img/logo.4e9b4aec.png";